/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryFee
 */
export interface DeliveryFee {
    /**
     * 
     * @type {number}
     * @memberof DeliveryFee
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryFee
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryFee
     */
    townId?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryFee
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryFee
     */
    deliveryConfigId?: number;
}

/**
 * Check if a given object implements the DeliveryFee interface.
 */
export function instanceOfDeliveryFee(value: object): value is DeliveryFee {
    return true;
}

export function DeliveryFeeFromJSON(json: any): DeliveryFee {
    return DeliveryFeeFromJSONTyped(json, false);
}

export function DeliveryFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryFee {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'id': json['id'] == null ? undefined : json['id'],
        'townId': json['townId'] == null ? undefined : json['townId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'deliveryConfigId': json['deliveryConfigId'] == null ? undefined : json['deliveryConfigId'],
    };
}

export function DeliveryFeeToJSON(json: any): DeliveryFee {
    return DeliveryFeeToJSONTyped(json, false);
}

export function DeliveryFeeToJSONTyped(value?: DeliveryFee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'id': value['id'],
        'townId': value['townId'],
        'courierId': value['courierId'],
        'deliveryConfigId': value['deliveryConfigId'],
    };
}

